<template>
  <el-select
    :value="value"
    size="small"
    @change="handleChange"
    placeholder="请选择类型"
    style="width: 100%"
  >
    <el-option :key="0" label="所有" :value="0"></el-option>
    <el-option-group v-for="(coptions, key) in options" :key="key" :label="key">
      <el-option v-for="(v, k) in coptions" :key="k" :label="v" :value="k">
      </el-option>
    </el-option-group>
  </el-select>
</template>

<script>
import { messageTypes } from '@/service/getData'

export default {
  props: {
    value: '',
  },
  data() {
    return {
      options: {},
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      let res = await messageTypes()
      if (res.status == 0) {
        this.options = res.data
      }
    },
    handleChange(e) {
      this.$emit('input', e)
    },
  },
}
</script>
<style>
.select-err .el-input__inner {
  border-color: #f56c6c;
}
</style>